/* LMM supplemental series-alias routing for category-led predictive search. Draft only. */
(function () {
  'use strict';
  if (window.LMMSeriesAliasSearch) return;
  window.LMMSeriesAliasSearch = '2026.08.14-series-4';

  /* Zentrale Routing-Entscheidung auch fuer die Overlay-Handler (Chris
     2026-08-14). Vorher routeten die submit-/keydown-Listener dieses Overlays
     JEDE Serienfamilien-Erkennung ungeprueft — sie liefen NACH dem gegateten
     Engine-Handler und uebernahmen genau die Faelle, die
     LMMRelevance.routingErlaubt soeben blockiert hatte ("Dulux L 36W
     dimmbar", "2G11 Fassung"). Jetzt gilt ueberall dieselbe Regel; faellt
     die Entscheidung negativ aus, laeuft die native Suche unveraendert
     weiter. Ohne LMMRelevance bleibt das Verhalten wie bisher. */
  function gateErlaubt(query, result) {
    if (!result || result.mode !== 'route' || !result.targetUrl) return false;
    if (!window.LMMRelevance) return true;
    return typeof window.LMMRelevance.routingErlaubt === 'function'
      ? window.LMMRelevance.routingErlaubt(query, result)
      : window.LMMRelevance.reinerKategorieIntent(query);
  }

  var timer = 0;
  var installed = false;
  var catalogByHandle = new Map();

  function fold(value) {
    var text = String(value || '').toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');
    if (text.normalize) text = text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    return text.replace(/\s+/g, ' ').trim();
  }

  function refreshCatalog() {
    var engine = window.LMMSearchIntent;
    catalogByHandle = new Map();
    if (!engine || typeof engine.getCatalog !== 'function') return;
    engine.getCatalog().forEach(function (item) { catalogByHandle.set(item.handle, item); });
  }

  function item(handle) { return catalogByHandle.get(handle) || null; }

  function previewUrl(path) {
    var target = new URL(path, location.origin);
    var current = new URL(location.href);
    ['preview_theme_id', 'preview_key'].forEach(function (key) {
      if (current.searchParams.has(key) && !target.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
    });
    return target.pathname + target.search;
  }

  function familyFromQuery(raw) {
    var q = fold(raw).replace(/[–—−_\\]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!q) return null;
    if (/\b(?:ean|gtin|sku|artikelnummer|art\.?\s*nr\.?|bestellnummer)\b/.test(q) || /\b\d{6,14}\b/.test(q)) return null;
    if (/\b(?:g24q|g24d|gx24q|gx24d|2g7|2g10|2g11|g23)-\d\b/.test(q)) return null;

    var fourPin = /\b4\s*(?:pin|pins|p)\b/.test(q);
    var twoPin = /\b2\s*(?:pin|pins|p)\b/.test(q);
    var id = '';

    if (/\b(?:dulux\s*)?d\s*[/.-]\s*e\b/.test(q) || /^d\s+e\b/.test(q)) id = 'g24q';
    else if (/\b(?:dulux\s*)?t\s*[/.-]\s*e\b/.test(q) || /^t\s+e\b/.test(q)) id = 'gx24q';
    else if (/\b(?:dulux\s*)?s\s*[/.-]\s*e\b/.test(q) || /^s\s+e\b/.test(q)) id = '2g7';
    else if (/\bpl\s*[-/]?\s*c\b|\bplc\b/.test(q)) id = fourPin ? 'g24q' : 'g24d';
    else if (/\bpl\s*[-/]?\s*t\b|\bplt\b/.test(q)) id = fourPin ? 'gx24q' : 'gx24d';
    else if (/\bpl\s*[-/]?\s*s\b|\bpls\b/.test(q)) id = fourPin ? '2g7' : 'g23';
    else if (/\bpl\s*[-/]?\s*l\b|\bpll\b/.test(q)) id = '2g11';
    else if (/\bdulux\s+d\b/.test(q)) id = fourPin ? 'g24q' : 'g24d';
    else if (/\bdulux\s+t\b/.test(q)) id = fourPin ? 'gx24q' : 'gx24d';
    else if (/\bdulux\s+s\b/.test(q)) id = fourPin ? '2g7' : 'g23';
    else if (/\bdulux\s+l\b/.test(q)) id = '2g11';
    else if (/\bdulux\s+f\b/.test(q)) id = '2g10';
    else if (/\bg\s*24\s*q\b|\bg24q\b/.test(q)) id = 'g24q';
    else if (/\bg\s*24\s*d\b|\bg24d\b/.test(q)) id = 'g24d';
    else if (/\bgx\s*24\s*q\b|\bgx24q\b/.test(q)) id = 'gx24q';
    else if (/\bgx\s*24\s*d\b|\bgx24d\b/.test(q)) id = 'gx24d';
    else if (/\b2\s*g\s*7\b|\b2g7\b/.test(q)) id = '2g7';
    else if (/\b2\s*g\s*10\b|\b2g10\b/.test(q)) id = '2g10';
    else if (/\b2\s*g\s*11\b|\b2g11\b/.test(q)) id = '2g11';
    else if (/\bg\s*23\b|\bg23\b/.test(q)) id = 'g23';
    if (!id) return null;

    var map = {
      g24q: { general:'g24q-sockel-4-pins', led:'g24q-led-leuchtmittel', label:'Dulux D/E · G24q' },
      g24d: { general:'g24d-sockel-2-pins', led:'g24d-led-leuchtmittel', label:'Dulux D · G24d' },
      gx24q:{ general:'gx24q-sockel-4-pins', led:'gx24q-led-leuchtmittel', label:'Dulux T/E · GX24q' },
      gx24d:{ general:'gx24d-sockel-2-pins', led:'gx24d-led-leuchtmittel', label:'Dulux T · GX24d' },
      '2g7':{ general:'2g7-sockel', led:'', label:'Dulux S/E · 2G7' },
      '2g10':{ general:'2g10-sockel', led:'2g10-led-leuchtmittel', label:'Dulux F · 2G10' },
      '2g11':{ general:'2g11-sockel', led:'2g11-led-leuchtmittel', label:'Dulux L · 2G11' },
      g23:{ general:'g23-sockel', led:'g23-led-leuchtmittel', label:'Dulux S · G23' }
    };
    var family = map[id];
    if (!family) return null;
    family.id = id;
    family.query = q;
    family.technology = /\bled\b/.test(q) ? 'led' : 'fluorescent';
    family.twoPin = twoPin;
    family.fourPin = fourPin;
    return family;
  }

  function modifiers(q) {
    var pairs = [];
    var engine = window.LMMSearchIntent;
    if (!engine || typeof engine.makeCollectionUrl !== 'function') return { pairs:pairs, watt:'', kelvin:'' };

    var watt = '';
    var numbers = (q.match(/\b\d{1,3}(?:[.,]\d+)?\b/g) || []).filter(function (n) {
      var value = Number(n.replace(',', '.'));
      if ([2,4,827,830,840,865].indexOf(value) !== -1) return false;
      return value >= 4 && value <= 80;
    });
    var explicitWatt = q.match(/\b(\d{1,3}(?:[.,]\d+)?)\s*w(?:att)?\b/);
    if (explicitWatt) watt = explicitWatt[1].replace(',', '.');
    else if (numbers.length === 1) watt = numbers[0].replace(',', '.');
    if (watt && watt.indexOf('.') === -1) watt += '.0';
    if (watt) pairs.push(['filter.p.m.specs.wattage', watt]);

    var kelvin = '';
    if (/\b827\b/.test(q)) kelvin = '2700';
    else if (/\b830\b/.test(q)) kelvin = '3000';
    else if (/\b840\b/.test(q)) kelvin = '4000';
    else if (/\b865\b/.test(q)) kelvin = '6500';
    else if (/warm\s*weiss|warmweiss/.test(q)) {
      pairs.push(['filter.p.m.specs.kelvin', ['2700','3000']]);
      kelvin = 'warmweiß';
    }
    if (kelvin && kelvin !== 'warmweiß') pairs.push(['filter.p.m.specs.kelvin', kelvin]);
    return { pairs:pairs, watt:watt, kelvin:kelvin };
  }

  function applicationFromQuery(q) {
    if (/\bled\b|led\s*(?:ersatz|alternative)/.test(q)) return 'led';
    if (/\buv\s*[- ]?a\b|\buva\b|actinic|schwarzlicht/.test(q)) return 'uva';
    if (/\buv\s*[- ]?b\b|\buvb\b|lichttherapie/.test(q)) return 'uvb';
    if (/\buv\s*[- ]?c\b|\buvc\b|entkeim|\btuv\b/.test(q)) return 'uvc';
    return '';
  }

  function categoryCard(candidate, url, note) {
    return candidate ? {
      title:candidate.title,
      url:previewUrl(url || candidate.url),
      note:note || '',
      count:Number(candidate.count || 0),
      image:candidate.image || ''
    } : null;
  }

  function brandCategory(brand) {
    var engine = window.LMMSearchIntent;
    if (!brand || !engine || typeof engine.getCatalog !== 'function') return null;
    return engine.getCatalog().filter(function (candidate) {
      return candidate.brand === brand && /kompaktleuchtstofflampen/.test(candidate.handle);
    }).sort(function (a, b) {
      return Number(b.count || 0) - Number(a.count || 0);
    })[0] || null;
  }

  function resolveSeries(raw) {
    var engine = window.LMMSearchIntent;
    if (!engine || typeof engine.getCatalog !== 'function' || typeof engine.makeCollectionUrl !== 'function') return null;
    if (typeof engine.isIdentifierQuery === 'function' && engine.isIdentifierQuery(raw)) return null;
    if (!catalogByHandle.size) refreshCatalog();
    var family = familyFromQuery(raw);
    if (!family) return null;

    var mod = modifiers(family.query);
    var application = applicationFromQuery(family.query);
    var explicitUvC = /\buv\s*[- ]?c\b|\buvc\b/.test(family.query);
    var brand = typeof engine.detectBrand === 'function' ? engine.detectBrand(family.query) : '';
    var vendors = brand && typeof engine.vendorValues === 'function' ? engine.vendorValues(brand) : [];
    var targetPairs = mod.pairs.slice();
    if (vendors.length && engine.filterKeys && engine.filterKeys.vendor) targetPairs.push([engine.filterKeys.vendor, vendors]);
    var primaryHandle = family.technology === 'led' && family.led && item(family.led) ? family.led : family.general;
    if (explicitUvC && item('uv-c-lampen-entkeimung')) primaryHandle = 'uv-c-lampen-entkeimung';
    var primary = item(primaryHandle);
    if (!primary) return null;
    var primaryUrl = engine.makeCollectionUrl(primary.handle, targetPairs);
    var fallbackUrl = mod.watt ? engine.makeCollectionUrl(primary.handle, []) : (vendors.length ? engine.makeCollectionUrl(primary.handle, mod.pairs) : '');

    var specificCategory = brandCategory(brand);
    var applicationHandles = application === 'uva'
      ? ['uv-a-lampen-insekten-haerter','schwarzlichtlampen']
      : application === 'uvb'
        ? ['uv-b-lampen-lichttherapie']
        : application === 'uvc'
          ? ['uv-c-lampen-entkeimung']
          : ['uv-c-lampen-entkeimung','uv-a-lampen-insekten-haerter','uv-b-lampen-lichttherapie'];
    var handles = [family.general, 'kompaktleuchtstofflampen']
      .concat(applicationHandles, [family.led, 'led-ersatz-kompaktleuchtstofflampen', specificCategory && specificCategory.handle, family.general]);
    var seen = new Set();
    var categories = handles.map(item).filter(function (candidate) {
      if (!candidate || seen.has(candidate.handle)) return false;
      seen.add(candidate.handle); return true;
    }).slice(0,7).map(function (candidate) {
      return categoryCard(candidate, candidate.handle === primary.handle ? primaryUrl : candidate.url,
        candidate.handle === primary.handle ? family.label : candidate === specificCategory ? 'passender Hersteller' : 'passende Kategorie');
    });

    var basePairs = mod.pairs.filter(function (pair) { return pair[0] !== 'filter.p.m.specs.kelvin'; });
    var suggestions = [];
    var primaryLabel = primary.title + (mod.watt ? ' ' + mod.watt.replace('.', ',') + ' W' : '');
    suggestions.push({ label:primaryLabel, url:primaryUrl, note:family.label });
    [['830','3000','warmweiß'],['840','4000','neutralweiß'],['865','6500','tageslichtweiß'],['827','2700','extra warmweiß']].forEach(function (entry) {
      suggestions.push({
        label:family.label + (mod.watt ? ' ' + mod.watt.replace('.', ',') + ' W' : '') + ' /' + entry[0],
        url:engine.makeCollectionUrl(primary.handle, basePairs.concat([['filter.p.m.specs.kelvin',entry[1]]])),
        note:entry[2]
      });
    });
    if (family.led && item(family.led)) suggestions.push({ label:item(family.led).title, url:previewUrl(item(family.led).url), note:'LED-Alternative' });
    if (item(family.general) && family.general !== primary.handle) suggestions.push({ label:item(family.general).title, url:previewUrl(item(family.general).url), note:'klassische Ausführung' });
    [specificCategory && specificCategory.handle,'kompaktleuchtstofflampen','led-ersatz-kompaktleuchtstofflampen'].forEach(function (handle) {
      var candidate = item(handle);
      if (candidate) suggestions.push({ label:candidate.title, url:previewUrl(candidate.url), note:'verwandte Kategorie' });
    });

    var unique = new Set();
    suggestions = suggestions.filter(function (entry) {
      var key = entry.label + '|' + entry.url;
      if (unique.has(key)) return false;
      unique.add(key); return true;
    }).slice(0,10);

    return {
      version:'2026.08.14-series-4',
      query:String(raw || '').trim(),
      normalized:family.query,
      mode:application ? 'ambiguous' : 'route',
      reason:application ? 'series-family-application' : 'series-family-alias',
      targetUrl:primaryUrl,
      collectionFallbackUrl:fallbackUrl,
      targetLabel:primary.title,
      brand:brand,
      vendorValues:vendors,
      productGrouping:{ family:family.id, watt:mod.watt, application:application, brand:brand },
      nativeQuery:application === 'uvc' ? family.query.replace(/\buv\s*[- ]?c\b|\buvc\b/g, 'entkeimung') : family.query,
      categoryPriority:handles.filter(Boolean),
      categoryPrimaryHandle:family.general,
      categories:categories,
      suggestions:suggestions,
      nativeUrl:engine.nativeSearchUrl ? engine.nativeSearchUrl(raw) : '/search?q=' + encodeURIComponent(raw)
    };
  }

  function inputForBox(box) {
    var component = box.closest('predictive-search-component');
    return (component && component.querySelector('input[name="q"]')) || document.querySelector('.lmmh-search__form input[name="q"], input[name="q"]');
  }

  function hideNative(box) {
    /* Nur die Leermeldung ausblenden. Die Produkt-/Kategorien-Panes verwaltet
       ausschließlich das Layout-Skript (lmm-bestseller-sort, integrate) — ein
       hidden auf .lmm-predictive__sec--cats kollabiert sonst die rechte Spalte
       bei jedem Re-Render dauerhaft (integrate-Observer sieht Attribut-Änderungen nicht). */
    box.querySelectorAll('.lmm-predictive__none').forEach(function (element) {
      element.setAttribute('hidden','');
    });
  }

  function patchBox(box) {
    if (!(box instanceof HTMLElement) || !window.LMMSearchIntent || typeof window.LMMSearchIntent.panelMarkup !== 'function') return;
    var input = inputForBox(box);
    var query = input ? input.value.trim() : '';
    var result = resolveSeries(query);
    var existing = box.querySelector('[data-lmm-series-alias-panel]');

    if (!result) {
      if (existing) {
        existing.remove();
        delete box.dataset.lmmIntentQuery;
        delete box.dataset.lmmIntentActive;
        window.setTimeout(function () { window.LMMSearchIntent.enhanceAll(); }, 0);
      }
      return;
    }

    if (existing && existing.dataset.query === query) { hideNative(box); return; }
    box.querySelectorAll('[data-lmm-intent-panel]').forEach(function (element) { element.remove(); });
    var host = box.querySelector('.lmm-predictive__inner') || box.firstElementChild || box;
    var wrapper = document.createElement('div');
    wrapper.innerHTML = window.LMMSearchIntent.panelMarkup(result);
    var panel = wrapper.firstElementChild;
    panel.setAttribute('data-lmm-series-alias-panel','');
    panel.dataset.query = query;
    host.prepend(panel);
    hideNative(box);
    box.dataset.lmmIntentQuery = query;
    box.dataset.lmmIntentActive = 'route';
    var outer = box.closest('.lmm-predictive__panel') || box.parentElement;
    if (outer) outer.removeAttribute('hidden');
  }

  function patchAll() {
    clearTimeout(timer);
    timer = window.setTimeout(function () {
      document.querySelectorAll('[ref="predictiveSearchResults"], .lmm-predictive__results').forEach(patchBox);
    }, 8);
  }

  function install() {
    if (installed || !window.LMMSearchIntent) return;
    installed = true;
    refreshCatalog();
    var engine = window.LMMSearchIntent;
    var baseResolve = engine.resolve.bind(engine);
    engine.resolve = function (query) { return resolveSeries(query) || baseResolve(query); };
    engine.routeQuery = function (query, replace) {
      var result = engine.resolve(query);
      if (result.mode !== 'route' || !result.targetUrl) return false;
      if (replace) location.replace(result.targetUrl); else location.assign(result.targetUrl);
      return true;
    };

    document.addEventListener('input', function (event) {
      if (event.target instanceof HTMLInputElement && event.target.name === 'q') { observeComponents(); patchAll(); }
    }, true);
    document.addEventListener('focusin', function (event) {
      if (event.target instanceof HTMLInputElement && event.target.name === 'q') { observeComponents(); patchAll(); }
    }, true);
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('form[role="search"], .lmmh-search__form')) return;
      var input = form.querySelector('input[name="q"]');
      var result = input && resolveSeries(input.value);
      if (!result || !gateErlaubt(input.value, result)) return;
      event.preventDefault(); event.stopImmediatePropagation(); location.assign(result.targetUrl);
    }, true);
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' || event.isComposing || !(event.target instanceof HTMLInputElement) || event.target.name !== 'q') return;
      var result = resolveSeries(event.target.value);
      if (!result || !gateErlaubt(event.target.value, result)) return;
      event.preventDefault(); event.stopImmediatePropagation(); location.assign(result.targetUrl);
    }, true);
    observeComponents();
    patchAll();
  }

  var observedComponents = window.WeakSet ? new WeakSet() : null;
  function observeComponents() {
    /* Auf die Predictive-Komponenten gescoped statt document-weit: patchBox soll
       nicht bei jeder Seiten-Mutation (Lazy-Images, Widgets) erneut laufen. */
    if (!window.MutationObserver || !observedComponents) return;
    document.querySelectorAll('predictive-search-component').forEach(function (component) {
      if (observedComponents.has(component)) return;
      observedComponents.add(component);
      new MutationObserver(function (mutations) {
        var relevant = mutations.some(function (mutation) {
          return mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length);
        });
        if (relevant) patchAll();
      }).observe(component, { childList:true, subtree:true });
    });
  }

  document.addEventListener('lmm:search-intent-ready', install, { once:true });
  if (window.LMMSearchIntent && document.readyState !== 'loading') install();
})();
